import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const TenantUsersRowActionsStyled = styled.div`
    display: flex;
    gap: ${owcTheme['one-spacing-gap-xs']};
`;
